import React from 'react';
import PropTypes from 'prop-types';

import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { LinkBuilder } from 'helpers/link-builder';
import { isAuthCandidate, Role } from 'helpers/user';
import { NavLink } from 'react-router-dom';

const LinkCandidateProfile = props => {
  const {
    id,
    name,
    user,
    cls,
    clsSpan,
    styleSpan,
    viewProfile,
    viewAsRecruiter,
    isClickByStrongEnabled,
  } = props;

  let link =
    ((viewAsRecruiter || !Role.isCandidate(user)) &&
      Role.isRecruiterDefault(user)) ||
    (!Role.isRecruiter(user) && !Role.isCandidate(user))
      ? '#'
      : LinkBuilder.getProfileLink(id);

  const onClickProfileLink = (e, user) => {
    if (
      ((!viewAsRecruiter && !viewProfile) ||
        (viewAsRecruiter || !Role.isCandidate(user))) &&
      Role.isRecruiterDefault(user)
    ) {
      UpgradeRecruiterAccount();
      e.preventDefault();
    } else if (!Role.isRecruiter(user) && !Role.isCandidate(user, true)) {
      e.preventDefault();
    }
  };

  const isLink =
    !isAuthCandidate(user, id) &&
    ((Role.isCandidate(user) && viewProfile) ||
      (Role.isRecruiter(user) &&
        !Role.isRecruiterDefault(user) &&
        viewAsRecruiter));

  return isLink ? (
    <NavLink
      to={link}
      className={cls}
      onClick={e => onClickProfileLink(e, user)}
    >
      {name}
    </NavLink>
  ) : (
    <strong
      className={clsSpan}
      style={styleSpan}
      onClick={e => isClickByStrongEnabled && onClickProfileLink(e, user)}
    >
      {name}
    </strong>
  );
};

LinkCandidateProfile.propTypes = {
  user: PropTypes.object.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  cls: PropTypes.string,
  clsSpan: PropTypes.string,
  styleSpan: PropTypes.object,
  viewProfile: PropTypes.bool,
  viewAsRecruiter: PropTypes.bool,
};

export default LinkCandidateProfile;
